import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
import { ArrecadacaoAutomaticaMesConsumoEnum } from "core/features/arrecadacoes/enums";

export interface SelectMesConsumoProcessarArrecadacaoProps<T = any>
  extends SelectBaseAntdProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectMesConsumoProcessarArrecadacao({
  value,
  onChange,
  ...rest
}: SelectMesConsumoProcessarArrecadacaoProps) {
  return (
    <SelectBaseAntd
      size="large"
      placeholder="Selecione"
      value={value}
      allowClear
      getPopupContainer={(node) => node.parentNode}
      showSearch
      onChange={onChange}
      optionFilterProp="label"
      options={[
        {
          label: "Mesmo mês da data de processamento",
          value: ArrecadacaoAutomaticaMesConsumoEnum.MesProcessamento,
        },
        {
          label: "Mês anterior à data de processamento",
          value: ArrecadacaoAutomaticaMesConsumoEnum.MesAnteriorProcessamento,
        },
      ]}
      {...rest}
    />
  );
}

export default SelectMesConsumoProcessarArrecadacao;
